/**
 * @generated SignedSource<<696b11f2308d41c96178c6e2e68ecd23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MapElementsVectorGrid_map",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasElements",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vectorTileUrl",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapClusterizedPointMarkers_map"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MapElementsVectorGridTileLayerStyles_map"
    }
  ],
  "type": "Map",
  "abstractKey": "__isMap"
};

node.hash = "f516ecbfd00257ff1a156c60bc2c9ef0";

module.exports = node;
